import React from 'react';
import block from 'bem-cn';

import Button from 'components/Button';
import Spinner from 'components/Spinner/view/desktop';
import SVG from 'components/SVG';
import Input from 'components/Input';
import Switcher from 'components/Switcher/Switcher';

import { formateNumber } from 'shared/helpers';
import { convertBalanceToNum } from 'shared/helpers/convertBalanceToNum';
import parseNumberFromString from 'shared/helpers/parseNumberFromString';

import useDepositModel from '../../../../model/useDepositModel';
import { useAmountTypes, userTypes } from '../../../../data';
import './Deposit.scss';

const b = block('deposit');

const Deposit = () => {
  const {
    actionProcessing,
    amount,
    changeValue,
    balance,
    locale,
    onSubmit,
    players,
    history,
    bonusAmount,
    bonusPercentAmount,
    handleBonusAmountChange,
    handleBonusPercentChange,
    handleIsBonusChange,
    handleRememberBonusSelectionChange,
    isBonus,
    targetRole,
    setAmount,
    rememberBonusSelection,
    isRememberBonusDisabled,
    isDirectPlayer,
  } = useDepositModel();
  const { types } = useAmountTypes();

  if (actionProcessing) return <Spinner isLoading={actionProcessing} />;

  // const handleAllButton = () => {
  //   setAmount(parseNumberFromString(convertBalanceToNum(balance)));
  // };

  return (
    <div className={b()}>
      <div className={b('wrapper')}>
        <div className={b('top')}>
          <div className={b('header')}>{locale.deposit}</div>
          <div className={b('header', { small: true })}>{locale.transferOfFunds}</div>
          <div className={b('user-blocks')}>
            {players.map((player, index) => (
              <div className={b('user-block')} key={index}>
                <div className={b('user-block-title')}>{player.title}</div>
                <div className={b('user-block-wrapper')}>
                  <div className={b('user-block-left')}>
                    <SVG svgProps={{ svg: userTypes[player.role].icon }} className={b('user-block-icon')} />
                    <div className={b('user-block-info')}>
                      <span>{player.username}</span>
                      <div className={b('user-block-info-type', { role: player.role })}>
                        {userTypes[player.role].type}
                      </div>
                    </div>
                  </div>
                  <div className={b('user-block-right')}>
                    <span>{locale.balance}:</span>
                    <span>{player.balance}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className={b('amount-types')}>
            {Object.keys(types).map((type, index) => (
              <div className={b('amount-types-item')} onClick={() => changeValue(type)} key={index}>
                {formateNumber(type)}
              </div>
            ))}
          </div>

          <div className={b('inputs')}>
            <div className={b('inputs-block')}>
              <p className={b('amount-title')}>{locale.enterAmount}</p>
              <div className={b('amount-input-block')}>
                <p className={b('amount-subtitle')}>{locale.amount}</p>
                <div className={b('amount-input-wrapper')}>
                  <div className={b('amount-input')}>
                    <Input
                      placeholder={locale.amount}
                      withEye
                      validState={amount && Number(amount) > 0 ? 2 : 3}
                      onChange={changeValue}
                      value={amount}
                      name="amount"
                      withFormatting
                    />
                  </div>
                  {/* <div className={b('amount-all-btn')}>
                    <Button callBack={handleAllButton} size="low" text={locale.all1} />
                  </div> */}
                </div>
              </div>
            </div>

            {targetRole === '0' && (
              <div className={b('inputs-block')}>
                <div className={b('bonus-title')}>
                  <p className={b('bonus-title-value')}>{locale.doYouWantToDepositABonus}</p>
                  <div className={b('switcher')}>
                    <Switcher isActive={isBonus} onSwitch={handleIsBonusChange} />
                  </div>
                </div>

                <div className={b('bonus-inputs')}>
                  <div className={b('bonus-input')}>
                    <Input
                      placeholder={locale.amount}
                      validState={bonusAmount && 4}
                      onChange={handleBonusAmountChange}
                      value={bonusAmount}
                      name="amount"
                      withFormatting
                      isBonus
                      bonusPlaceholder={locale.currency}
                      disabled={!isBonus}
                    />
                  </div>

                  <div className={b('bonus-input')}>
                    <Input
                      placeholder={locale.amount}
                      validState={bonusPercentAmount && 4}
                      onChange={handleBonusPercentChange}
                      value={bonusPercentAmount}
                      name="amount"
                      withFormatting
                      isBonus
                      isPercentFormat
                      bonusPlaceholder={locale.percent}
                      disabled={!isBonus}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {isDirectPlayer && (
          <div className={b('remember-bonus')}>
            <p className={b('remember-bonus-title')}>{locale.rememberBonusSelection}</p>
            <div className={b('switcher')}>
              <Switcher
                isActive={rememberBonusSelection}
                onSwitch={handleRememberBonusSelectionChange}
                disabled={isRememberBonusDisabled}
              />
            </div>
          </div>
        )}
        <div className={b('bottom')}>
          <Button color="full-transparent" callBack={history.goBack} text={locale.cancel} size="low" />
          <Button callBack={onSubmit} type="submit" size="low" text={locale.deposit} />
        </div>
      </div>
    </div>
  );
};

export default Deposit;
